<p-card class="mx-2">
  <p-accordion [multiple]="true">
    <p-accordionTab
      header="{{ 'FacilityPrinter.SearchForm.Header' | translate }}"
      [(selected)]="isOpenedPrinterSearchFormTab"
    >
      <ng-content *ngTemplateOutlet="printerSearchFormTemplate"></ng-content>
    </p-accordionTab>
    <p-accordionTab
      header="{{ 'FacilityPrinter.MainTable.Header' | translate }}"
      [(selected)]="isOpenedPrinterInfoTab"
    >
      <ng-content *ngTemplateOutlet="printerDataTemplate"></ng-content>
    </p-accordionTab>
  </p-accordion>
</p-card>

<ng-template #printerSearchFormTemplate>
  <form [formGroup]="searchFormGroup">
    <!-------------------------------------- Form Field ---------------------------------------------->
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formFacilityCode">{{
          "FacilityPrinter.SearchForm.Column.FacilityCode" | translate
        }}</label>
        <laas-facility-dropdown
          [isSingle]="true"
          formControlName="facilityCode">
        </laas-facility-dropdown>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formPrinterType">{{
          "FacilityPrinter.SearchForm.Column.PrinterType" | translate
        }}</label>
        <p-multiSelect
          formControlName="printerTypes"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          [options]="printerTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formDeliveryType">{{
          "FacilityPrinter.SearchForm.Column.DeliveryType" | translate
        }}</label>
        <p-multiSelect
          formControlName="deliveryTypes"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          [options]="deliveryTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formLetterHeadOrgId">{{
          "FacilityPrinter.SearchForm.Column.LetterHeadOrgId" | translate
        }}</label>
        <p-multiSelect
          formControlName="letterHeadOrgIds"
          optionLabel="label"
          optionValue="value"
          [options]="letterHeadOrgIdOptions"
          [filter]="true"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
          filterBy="label, value"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formForwarderCode">{{
          "FacilityPrinter.SearchForm.Column.ForwarderCode" | translate
        }}</label>
        <laas-multiSelect
          formControlName="forwarderCodes"
          [virtualScroll]="true"
          [virtualScrollItemSize]="40"
          [filter]="true"
          filterBy="label,value"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
          [options]="forwarderCodeOptions"
        ></laas-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formConsigneeKey">{{
          "FacilityPrinter.SearchForm.Column.ConsigneeKey" | translate
        }}</label>
        <laas-customer-dropdown
          formControlName="consigneeKeys"
          [showToggleAll]="false"
          [isMultiple]="true"
          [showLabel]="false"
          [divClass]="'field'"
          [showAllOptionItem]="true"
        ></laas-customer-dropdown>
      </div>
    </div>
    <!-------------------------------------- Form Button ---------------------------------------------->
    <div>
      <button
        pButton
        label="{{ 'Common.Button.Search' | translate }}"
        (click)="searchBtnClick()"
      ></button>
      <button
        pButton
        label="{{ 'Common.Button.Reset' | translate }}"
        class="p-button-secondary ml-2"
        (click)="resetBtnClick()"
      ></button>
    </div>
  </form>
</ng-template>

<ng-template #printerDataTemplate>
  <div class="mt-2">
    <laas-data-table
      #printerTable
      [dataKey]="'rowId'"
      [tableKey]="printerPreferenceKey"
      [value]="printerData"
      [defaultColumns]="columnOfFacilityPrinter"
      [loading]="isPrinterTableLoading"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [createNewRow]="createNewRow"
      [inputValid]="dataInputValid"
      (createRow)="createRow($event)"
      (savedData)="saveData($event)"
      (restoreData)="restoreData()"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      (onRowSelect)="onRowSelect($event)"
    >
      <ng-template pTemplate="caption">
        <button
          (click)="exportBtnClick($event)"
          pButton
          class="p-button-info ml-2"
          label="{{ 'Common.Button.Export' | translate }}"
        ></button>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'printerType'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : printerTypeOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'forwarderCode'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : forwarderCodeOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'letterHeadOrgId'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : letterHeadOrgIdOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : consigneeKeyOptionsMapping | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'enable'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : enableOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'__action'">
              -
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'printerCode'" class="p-fluid">
            <input
              type="text"
              pInputText
              [(ngModel)]="rowData[col.field]"
            />
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'printerType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="printerTypeOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'deliveryType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="deliveryTypeOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="forwarderCodeOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'letterHeadOrgId'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="letterHeadOrgIdOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
            <laas-customer-dropdown
              [isSingle]="true"
              [showClear]="true"
              [permissionCode]="editPermissionCode"
              [divClass]="'p-fluid'"
              [(ngModel)]="rowData[col.field]"
              [showAllOptionItem]="true">
            </laas-customer-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid"> {{ 'Common.Button.Required' | translate }} </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'enable'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : enableOptions) : 'Common.Message.ChooseOption' | translate }}"
              [options]="enableOptions"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>
          </ng-container>

          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>

        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'printerType'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : printerTypeOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : forwarderCodeOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'letterHeadOrgId'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : letterHeadOrgIdOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : consigneeKeyOptionsMapping | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'enable'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : enableOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>

        </ng-container>
      </ng-template>

    </laas-data-table>
  </div>
</ng-template>
